import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ArrowRight, Check } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import SubscriptionWizardSteps from './SubscriptionWizardSteps';

interface SubscriptionWizardLayoutProps {
  children: React.ReactNode;
  currentStep: number;
  totalSteps: number;
  title: string;
  description: string;
  onNext?: () => void;
  onPrevious?: () => void;
  isNextDisabled?: boolean;
  isComplete?: boolean;
  nextButtonText?: string;
}

const SubscriptionWizardLayout: React.FC<SubscriptionWizardLayoutProps> = ({
  children,
  currentStep,
  totalSteps,
  title,
  description,
  onNext,
  onPrevious,
  isNextDisabled = false,
  isComplete = false,
  nextButtonText,
}) => {
  const navigate = useNavigate();

  const handleStepClick = (step: number) => {
    // Navegar para o step anterior quando clicado
    if (step < currentStep) {
      navigate(`../step${step}`, { relative: 'path' });
    }
  };

  return (
    <div className="container mx-auto py-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <div>
          <h1 className="text-3xl font-extrabold tracking-tight">{title}</h1>
          <p className="text-muted-foreground">{description}</p>
        </div>
        <div className="flex gap-2">
          {/* Aqui poderia ficar botões adicionais se necessário */}
        </div>
      </div>

      {/* Componente de Steps */}
      <SubscriptionWizardSteps 
        currentStep={currentStep} 
        onStepClick={handleStepClick}
        className="mt-6"
      />

      <Card className="mt-6">
        <CardContent className="pt-6">
          {children}
        </CardContent>
      </Card>

      <div className="mt-6 flex justify-between">
        {currentStep > 1 ? (
          <Button
            variant="outline"
            onClick={onPrevious}
            className="gap-1"
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar
          </Button>
        ) : (
          <Button
            variant="outline"
            onClick={() => navigate('/subscriptions')}
            className="gap-1"
          >
            <ArrowLeft className="h-4 w-4" />
            Cancelar
          </Button>
        )}

        {currentStep < totalSteps ? (
          <Button
            onClick={onNext}
            disabled={isNextDisabled}
            className="gap-1"
          >
            {nextButtonText || 'Próximo'}
            <ArrowRight className="h-4 w-4" />
          </Button>
        ) : (
          <Button
            onClick={onNext}
            disabled={isNextDisabled}
            className="gap-1 bg-green-600 hover:bg-green-700"
          >
            {nextButtonText || 'Finalizar'}
            <Check className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default SubscriptionWizardLayout; 